import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message, Switch } from "antd";
import Layout from "../components/Layout/Layout";
import DashboardLayout from "./components/DashboardLayout";
import "./css/Account.css";
import { apiClient } from "../config/api.client";
import { userExist } from "../redux/features/userSlice";
import { getMarketingConsent, updateMarketingConsent } from "../services/user.service";

const Account = () => {
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.user);
	const [form, setForm] = useState(null);
	const [loading, setLoading] = useState(null);
	const [marketingConsent, setMarketingConsent] = useState(false);
	const [consentLoading, setConsentLoading] = useState(true);

	const fetchMarketingConsent = async () => {
		try {
			const data = await getMarketingConsent();
			setMarketingConsent(data?.marketingConsent === true);
		} catch (error) {
			console.log(error);
		} finally {
			setConsentLoading(false);
		}
	};

	const handleConsentChange = async (checked) => {
		setConsentLoading(true);
		try {
			const data = await updateMarketingConsent(checked);
			setMarketingConsent(data?.marketingConsent ?? checked);
			message.success(checked ? "You're subscribed to email offers" : "You've been unsubscribed from email offers");
		} catch (error) {
			message.error("Could not update your email preference");
		} finally {
			setConsentLoading(false);
		}
	};

	const handleUpdate = async (e) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (form?.email === "" || form?.fname === "") {
			return message.error(
				`Please Enter ${form?.fname === "" ? "your name" : "your email"}`
			);
		}
		if (!emailRegex.test(form?.email)) {
			setLoading(false);
			return message.error("Please enter a valid email address");
		}
		if (form?.fname?.length < 5) {
			return message.error("Name should be more than 5 characters");
		}
		e.preventDefault();
		try {
			const res = await apiClient.post("/user/updateprofile", form, {
				headers: {
					Authorization: "Bearer " + localStorage.getItem("token"),
				},
			});
			if (res.data.success) {
				message.success(res.data.message);
				dispatch(userExist(res.data.data));
			} else {
				message.error(res.data.message);
			}
		} catch (error) {
			console.log(error);
		}
	};
	const getUserData = async () => {
		apiClient
			.post(
				"/user/getUserData",
				{},
				{
					headers: {
						Authorization: "Bearer " + localStorage.getItem("token"),
					},
				}
			)
			.then((res) => {
				if (res.data.success) {
					setForm(res.data.data.user);
				} else {
					localStorage.removeItem("token");
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	useEffect(() => {
		getUserData();
		fetchMarketingConsent();
	}, []);

	return (
		<Layout>
			<DashboardLayout>
				<div className="user-accout-details" style={{ minHeight: "300px" }}>
					<div className="row">
						<div className="col-12 col-sm-6 col-md-12 col-lg-6">
							<div className="col-12">
								<div
									className={`form-fields mb-3 ${user?.fname === null && "warning"
										}`}
								>
									<label htmlFor="" className="form-label text-dark">
										Name {!user?.fname && "(Min 5 Characters)"}
									</label>
									{!user?.fname && (
										<input
											name="fname"
											type="text"
											placeholder="Enter your name"
											className="form-control"
											onChange={(e) =>
												setForm({ ...form, fname: e.target.value })
											}
										/>
									)}
									{user?.fname && <h6 className="text-dark">{form?.fname}</h6>}
								</div>
							</div>
							<div className="col-12">
								<div
									className={`form-fields mb-3 ${user?.fname === null && "warning"
										}`}
								>
									<label htmlFor="" className="form-label text-dark">
										Email
									</label>
									{!user?.email && (
										<input
											type="text"
											placeholder="Enter email"
											className="form-control"
											onChange={(e) =>
												setForm({ ...form, email: e.target.value })
											}
										/>
									)}
									{user?.email && <h6 className="text-dark">{form?.email}</h6>}
								</div>
							</div>
							<div className="col-12">
								<div className="form-fields mb-3">
									<label htmlFor="" className="form-label text-dark">
										Mobile
									</label>
									<h6 className="text-dark">{form?.mobile}</h6>
								</div>
							</div>
							<div className="col-12">
								<div className="form-fields mb-3 d-flex align-items-center justify-content-between">
									<label htmlFor="marketingConsentToggle" className="form-label text-dark m-0">
										Email me about diamond deals and offers
									</label>
									<Switch
										id="marketingConsentToggle"
										checked={marketingConsent}
										loading={consentLoading}
										onChange={handleConsentChange}
									/>
								</div>
							</div>
							{/* <div className="col-12">
                <div className="form-fields mb-3">
                  <label htmlFor="" className="form-label text-dark">
                    Password
                  </label>
                  <input
                    onChange={(e) =>
                      setForm({ ...form, password: e.target.value })
                    }
                    type="text"
                    className="form-control"
                  />
                </div>
              </div> */}
							{(!user?.email || !user?.fname) && (
								<button
									onClick={handleUpdate}
									className="w-100 updateprofilebtn"
								>
									Update
								</button>
							)}
						</div>
					</div>
				</div>
			</DashboardLayout>
		</Layout>
	);
};

export default Account;
